import { useSettings } from "utils/settingsContext";

/**
 * Returns a boolean to determine if provided currency is a virtual currency
 * base on the integratorSettings.virtualCurrencies object
 * The currency must be an exact match ie. VCU !== vcu
 *
 * @param {string} currency
 * @returns {function(value: Number|string): string}
 */
const useIsVirtualCurrency = (currency) => {
  const { integratorSettings } = useSettings();

  const virtualCurrencies = integratorSettings?.virtualCurrencies?.currencies || {};

  return !!virtualCurrencies[currency];
};

export default useIsVirtualCurrency;
